import React from 'react';
import StarRatings from 'react-star-ratings';

// starDimension/starSpacing default to the original values so every existing
// caller renders exactly as before; only callers that opt in get smaller stars.
const StaticStarUI = ({ rating, starDimension = '25px', starSpacing = '1px', ...props }) => {
  return (
    <StarRatings
      rating={rating}
      starRatedColor="#ffc110"
      numberOfStars={5}
      name="rating"
      starDimension={starDimension}
      starSpacing={starSpacing}
    />
  );
};

export default StaticStarUI;
